module.exports = __webpack_public_path__ + "static/media/xueshan_package.a28915d9.webp";